import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DataTableGraphCellBody = styled.div`
  display: flex;
  align-items: center;
`;

const GraphBody = styled.div`
  flex: 2;
`;

const GraphText = styled.div`
  flex: 1;
  text-align: right;
`;

const DataTableBodyCellGraph = ({ graph, text }) => (
  <DataTableGraphCellBody>
    <GraphBody>{graph}</GraphBody>
    {text && <GraphText>{text}</GraphText>}
  </DataTableGraphCellBody>
);

DataTableBodyCellGraph.propTypes = {
  graph: PropTypes.node,
  text: PropTypes.node,
};

export default DataTableBodyCellGraph;
